var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreviousIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49922 12.7998L14.1992 18.3998C14.5992 18.7998 15.1992 18.7998 15.5992 18.3998C15.9992 17.9998 15.9992 17.3998 15.5992 16.9998L10.6992 11.9998L15.5992 6.9998C15.9992 6.5998 15.9992 5.9998 15.5992 5.5998C15.3992 5.3998 15.1992 5.2998 14.8992 5.2998C14.5992 5.2998 14.3992 5.3998 14.1992 5.5998L8.49922 11.1998C8.09922 11.6998 8.09922 12.2998 8.49922 12.7998C8.49922 12.6998 8.49922 12.6998 8.49922 12.7998Z",
    fill: "#776F6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousIcon);
export default __webpack_public_path__ + "static/media/PreviousIcon.30ba901c5faafbb218e1dcbd45f53b25.svg";
export { ForwardRef as ReactComponent };